<!-- Dynamic Sidebar Container with Collapse Behavior -->
<div 
  class="relative flex flex-col h-full transition-all duration-300 overflow-hidden bg-white border-r border-[#c9d9f8]"
  [ngClass]="{'w-12': isDataPickerCollapsed, 'w-[32rem]': !isDataPickerCollapsed}"
  (click)="closeFunctionsDropDown()">

  <app-confirmation-popup 
    [isVisible]="showConfirmationPopup" 
    [message]="confirmationPopupMsg"
    [header]="confirmationPopupHeader" 
    [confirmAction]="confirmationCallbacks.confirmAction"
    [cancelAction]="confirmationCallbacks.cancelAction" 
    class="z-[51]">
  </app-confirmation-popup>
  
  <!-- Horizontal Expand Tab for Collapsed State -->
  <div *ngIf="isDataPickerCollapsed" 
    class="absolute top-0 left-0 cursor-pointer right-0 flex justify-center items-center h-10 rounded-b-md shadow hover:bg-gray-100"
    (click)="toggleCollapse(); $event.stopPropagation();">
    <button class="flex items-center focus:outline-none">
      <ui-icon name="chevron-right" class="stroke-[#0F49A0] stroke-[1.5px]" size="size-3"></ui-icon>
    </button>
  </div>

  <!-- Sidebar Content (Visible only in expanded state) -->
  <div class="main-content flex flex-col justify-between h-full"
       [ngClass]="{'hidden': isDataPickerCollapsed}">
    <div class="flex flex-col overflow-hidden sidebar">
      <div class="flex w-full p-3 rounded-lg border border-[#EAECF0] hover:border-[#77ABF9] transition-all">
        <!-- Toggle Button for Expanded State -->
        <button 
          class="bg-white border-r border-gray-300 p-2 hover:bg-gray-100 focus:outline-none mr-4"
          (click)="toggleCollapse(); $event.stopPropagation();">
          <ui-icon name="chevron-left" class="stroke-[#0F49A0] stroke-[1.5px]" size="size-3"></ui-icon>
        </button>

        <div class="flex items-center w-full">
          <ui-icon name="data-scopes" class="stroke-[#77ABF9] mr-3" size="size-4" />
          <div class="flex items-center cursor-pointer w-full relative"
            (click)="toggleSelectScope()">

            <div class="flex items-center flex-1">
              <p class="text-base truncate max-w-[70%]">
                {{ selectedScope?.name || "Select Scope" }}
              </p>
              <ui-icon *ngIf="selectedScope" name="alert" class="stroke-[#757575] cursor-pointer rotate-180 ml-2" size="size-5"
                (click)="toggleScopeOverView($event)"></ui-icon>
            </div>
            <ui-icon name="chevron-down" class="stroke-[#475467] ml-2" size="size-4" />

            <!-- Select Scope Modal -->
            <div *ngIf="isSelectScopeOpen"
              (click)="$event.stopPropagation()"
              class="fixed top-[120px] -ml-4 z-50 bg-white rounded-lg shadow border p-2 max-h-[300px] w-[370px] overflow-auto">
              <div class="flex items-center border border-[#D0D5DD] rounded-lg px-4 py-1 my-2">
                <img src="assets/icons/search.svg" alt="" class="mr-2" />
                <input
                  type="text"
                  placeholder="Search "
                  [(ngModel)]="searchScopeTerm"
                  (input)="filterScopes()"
                  class="focus:outline-none w-full"
                />
              </div>
            
              <div class="max-h-[240px] overflow-y-auto">
                <ng-container *ngIf="!loadingDatascopes; else loading">
                  <ul>
                    <li
                      *ngFor="let scope of filteredScopes"
                      (click)="selectScope(scope, $event)"
                      [ngClass]="{
                        'bg-[#77ABF9] text-white': tempSelectedScope?.name === scope.name,
                        'hover:bg-[#77ABF9] hover:text-white': true
                      }"
                      class="py-3 px-2 text-[14px] font-medium cursor-pointer rounded-lg mb-1"
                    >
                      {{ scope.name }}
                    </li>                    
                  </ul>
                </ng-container>
                <ng-template #loading>
                  <skeleton-app-flat-hierarchy [contentWidth]="'w-full pl-4'" />
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Search and filtering section -->
      <div class="flex items-center justify-between py-2 px-4 border-b border-[#EAECF0]">
        <div class="flex items-center w-full gap-3">
          <div class="flex-1 relative">
            <ui-icon name="search" class="stroke-[#5D5D5D] absolute left-3 top-1/2 -translate-y-1/2" size="size-5" />
            <input type="text"
              class="w-full pl-10 pr-4 py-2 rounded-lg border border-[#EAECF0] focus:border-[#77ABF9] outline-none disabled:cursor-not-allowed"
              placeholder="Search..."  
              [(ngModel)]="searchTerm"
              [disabled]="!isSelectedScope"
              (input)="onSearch()" />
          </div>
          <button
            class="p-2 rounded-lg hover:bg-gray-50"
            [title]="!(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)? 'Select a data scope to clear selections' : 'Clear All Selections'"
            (click)="!(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)? '' : clearAllClicked()">
            <img 
              [src]="'assets/img/eraser.svg'"
              [ngClass]="!(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)? 'opacity-50' : 'hover:stroke-blue-700'"
              class="w-5 h-5"
              alt="Clear all"
            />
          </button>
          <button class="flex items-center px-3 py-2 rounded-lg hover:bg-gray-50"
            [title]="!(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)? 'Select a data scope to apply filters' :'Apply Filters'"
            (click)="!(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)? '' : toggleFilterDropdown($event)">
            <ui-icon name="funnel" 
              [ngClass]="{
                'text-[#77ABF9]': appliedFilters.length > 0,
                'text-[#000000]': appliedFilters.length === 0,
                'opacity-50': !(selectedTablesForMeasures.length > 0 || selectedTablesForAttributes.length > 0)
              }" 
              size="size-5">
            </ui-icon>
            @if(appliedFilters.length > 0) {
              <span class="ml-1 text-sm text-[#77ABF9]">{{appliedFilters.length}}</span>
            }
          </button>

          <!-- Filter Dropdown -->
          <div *ngIf="isFilterDropdownOpen" (click)="$event.stopPropagation()"
            class="z-50 fixed top-[160px] left-[460px] bg-white rounded-xl border border-gray-300 shadow-2xl p-3 w-[1000px] custom-height ">
            <!-- close section -->
            <div class="flex justify-between">
              <app-agent-trigger [title]="'Build filters using Natural Language'" />
              <button (click)="confirmFilterPopUpClose()" class="p-2">
                <img src="assets/icons/close.svg" alt="" />
              </button>
            </div>

            <!-- Add New Filter Section -->
            <div class="p-4 m-2 border border-[#EAECF0] rounded-lg mb-8">
              <div class="flex items-center justify-between mb-2">
                <p class="text-[#5D5D5D] font-semibold text-sm">Add New Filter</p>
              </div>

              <div>
                <div>
                  <div
                    class="px-2 py-3 bg-[#f8f9fb] rounded-lg shadow border w-full flex gap-2 items-center border-[#cfd4dc] justify-evenly">
                    <select [(ngModel)]="filterTableSelected" class="ml-1 font-semibold text-center"
                      (ngModelChange)="onFilterTableSelected($event)">
                      <option value="" disabled selected>Choose Table</option>
                      <option *ngFor="let table of allTables" [value]="table.id">
                        {{ table.name }}
                      </option>
                    </select>

                    <select [(ngModel)]="filterColumnSelected" class="ml-2 font-semibold text-center"
                      (ngModelChange)="onFilterColumnChanges($event)">
                      <option value="" disabled selected>Choose Column</option>
                      <option *ngFor="let column of filterTableColumns" [value]="column?.parameters?.FQPN">
                        {{ column?.name }}
                      </option>
                    </select>

                    <select [(ngModel)]="selectedFilterOperator" class="ml-2 font-semibold text-center"
                      (ngModelChange)="clearNewFilterValue()">
                      <option value="" disabled selected>
                        Choose Operator
                      </option>
                      <option *ngFor="let operator of filterOperators" [value]="operator.key"
                        title="{{operator.label}}">
                        {{ operator.key }}
                      </option>
                    </select>
                    @if( isDateOrtTimeType(selectedFilterColumnType) && selectedFilterOperator !==
                    filterOperatorKeys.BETWEEN ){
                    <p-floatLabel>
                      <p-calendar [(ngModel)]="selectedDate" inputId="calendar-start-date" [iconDisplay]="'input'"
                        [showIcon]="false" [showTime]="true" [hourFormat]="'24'" [appendTo]="'body'" />
                      <label for="calendar-start-date">Choose a Date</label>
                    </p-floatLabel>
                    }@else if(isDateOrtTimeType(selectedFilterColumnType) && selectedFilterOperator ===
                    filterOperatorKeys.BETWEEN || selectedFilterOperator === filterOperatorKeys.NOT_BETWEEN){
                    <p-floatLabel>
                      <p-calendar [(ngModel)]="selectedFromDate" inputId="calendar-start-date"
                        [iconDisplay]="'input'" [showIcon]="false" [showTime]="true" [hourFormat]="'24'"
                        [appendTo]="'body'" />
                      <label for="calendar-start-date">Start Date</label>
                    </p-floatLabel>

                    <p-floatLabel>
                      <p-calendar [(ngModel)]="selectedToDate" inputId="calendar-end-date" [iconDisplay]="'input'"
                        [showIcon]="false" [showTime]="true" [hourFormat]="'24'" [appendTo]="'body'" />
                      <label for="calendar-end-date">End Date</label>
                    </p-floatLabel>
                    } @else if(!isDateOrtTimeType(selectedFilterColumnType) && selectedFilterOperator ===
                    filterOperatorKeys.BETWEEN || selectedFilterOperator === filterOperatorKeys.NOT_BETWEEN){
                    <input type="text" placeholder="Start Value" [(ngModel)]="fromValue"
                      class="ml-2 font-semibold text-center"
                      (keypress)="onFilterInputKeyPress($event, selectedFilterColumnType)" />
                    <input type="text" placeholder="End Value" [(ngModel)]="toValue"
                      class="ml-2 font-semibold text-center"
                      (keypress)="onFilterInputKeyPress($event, selectedFilterColumnType)" />
                    } @else{
                    <input type="text" placeholder="Value(s)" [(ngModel)]="filterValues"
                      class="ml-2 font-semibold text-center"
                      (keypress)="onFilterInputKeyPress($event, selectedFilterColumnType)" />
                    }
                    <!-- Add and cancel for filters -->
                    <span class="flex items-center">
                      <button
                        class="group bg-green-100 hover:bg-green-200  disabled:bg-gray-300 disabled:cursor-not-allowed transition px-4 h-10 rounded-lg ml-1 flex items-center justify-center"
                        (click)="addFilter()" [disabled]="isAddFilterDisabled()">
                        <img src="assets/img/check.png"
                          class="size-6 group-disabled:opacity-50 group-disabled:grayscale" alt="Check" />
                      </button>
                      <button
                        class="bg-red-100 hover:bg-red-200 transition px-4 h-10 rounded-lg ml-4 flex items-center justify-center"
                        (click)="clearAddFilterValues()">
                        <ui-icon name="close" class="stroke-red-600" size="size-5"></ui-icon>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Applied Filters Section -->
            <div class="p-4 m-2 border border-[#EAECF0] rounded-lg">
              <div class="flex items-center justify-between mb-3">
                <div class="flex flex-row items-center">
                  <p class="text-[#5D5D5D] font-semibold text-sm">
                    Applied Filters
                  </p>

                  @if(showDateTimeFormatPicker){
                  <!-- Date Time Format Picker -->
                  <select [(ngModel)]="selectedDateTimeFormat"
                  (ngModelChange)="onDateFormatChange($event)"
                  class="ml-5 text-[#5D5D5D] font-semibold text-sm
              border border-[#EAECF0] rounded px-2 py-1 bg-white
              focus:outline-none focus:ring focus:ring-blue-200
            ">
                    <option value="" disabled selected>Choose Date Time Format</option>
                    <option *ngFor="let format of dateTimeFormat" [value]="format.value"
                      title="{{  currentDate() | date: (format.value === 'custom' ? customDateFormat : format.value)}}">
                      {{ format.label }}
                    </option>
                  </select>

                  <!-- Custom format input field -->
                  <div *ngIf="selectedDateTimeFormat === 'custom'" class="ml-2 flex items-center">
                    <input 
                      type="text" 
                      [(ngModel)]="customDateFormat" 
                      (ngModelChange)="onCustomFormatChange($event)"
                      placeholder="e.g., dd MMM yyyy"
                      class="text-[#5D5D5D] font-semibold text-sm
                      border border-[#EAECF0] rounded px-2 py-1 bg-white
                      focus:outline-none focus:ring focus:ring-blue-200 w-40"
                      [ngClass]="{'border-red-500': !isCustomFormatValid(), 'border-gray-300': isCustomFormatValid()}"
                    />
                    <a 
                      href="https://angular.dev/api/common/DatePipe#pre-defined-format-options" 
                      target="_blank" 
                      class="ml-2" 
                      title="Custom Date Formats Documentation">
                      <ui-icon name="alert" class="stroke-[#757575] cursor-pointer rotate-180" size="size-5"></ui-icon>
                    </a>
                  </div>
                  }
                </div>
                <button class="text-[#0F49A0] text-xs font-semibold" (click)="clearAllFilters()">
                  Clear all Filters
                </button>
              </div>

              <!-- Show Applied Filters -->
              <div class="custom-height-filter-dropdown mb-2">
                <div>
                  <ul>
                    @if(selectedFilters.length > 0){
                    <li *ngFor="let filter of selectedFilters; let i = index"
                      class="text-[14px] font-medium cursor-pointer rounded-lg mb-1">
                      <!-- Applied Filters Edit Section -->
                      @if(filter.isEditing){
                      <div
                        class="px-4 py-1 bg-[#f8f9fb] rounded-lg shadow border w-full flex gap-2 items-center border-[#cfd4dc] text-gray-700 ">
                        <select [(ngModel)]="filter.table_id" class="ml-1 font-semibold text-center"
                          (ngModelChange)="onFilterTableEdited(filter,$event)">
                          <option value="" disabled selected>
                            Choose Table
                          </option>
                          <option *ngFor="let table of allTables" [value]="table.id">
                            {{ table.name }}
                          </option>
                        </select>

                        <select [(ngModel)]="filter.COLUMN_FQPN" class="ml-2 font-semibold text-center"
                          (change)="onFilterColumnEdited($event, filter)">
                          <option value="" disabled selected>
                            Choose Column
                          </option>
                          <option *ngFor="let column of getColumnsForEditedTable(filter.table_id)"
                            [value]="column?.parameters?.FQPN">
                            {{ column?.name }}
                          </option>
                        </select>

                        <select [(ngModel)]="filter.operator" class="ml-2 font-semibold text-center"
                          (change)="clearFilterValues(filter)">
                          <option value="" disabled selected>
                            Choose Operator
                          </option>
                          <option *ngFor="let operator of filterOperators" [value]="operator.key"
                            title="{{operator.label}}">
                            {{ operator.key }}
                          </option>
                        </select>

                        @if(isDateOrtTimeType(filter.COLUMN_TYPE ?? '') && !(filter.operator ===
                        filterOperatorKeys.BETWEEN || filter.operator === filterOperatorKeys.NOT_BETWEEN )){
                        <p-floatLabel>
                          <p-calendar [(ngModel)]="filter.fromDate" inputId="calendar-start-date"
                            [iconDisplay]="'input'" [showIcon]="false" [showTime]="true" [hourFormat]="'24'"
                            [appendTo]="'body'" />
                          <label for="calendar-start-date">Choose a Date</label>
                        </p-floatLabel>
                        }@else if(isDateOrtTimeType(filter.COLUMN_TYPE ?? '') && (filter.operator ===
                        filterOperatorKeys.BETWEEN || filter.operator === filterOperatorKeys.NOT_BETWEEN )){
                        <p-floatLabel>
                          <p-calendar [(ngModel)]="filter.fromDate" inputId="calendar-start-date"
                            [iconDisplay]="'input'" [showIcon]="false" [showTime]="true" [hourFormat]="'24'"
                            [appendTo]="'body'" />
                          <label for="calendar-start-date">From Date</label>
                        </p-floatLabel>

                        <p-floatLabel>
                          <p-calendar [(ngModel)]="filter.toDate" inputId="calendar-end-date" [iconDisplay]="'input'"
                            [showIcon]="false" [showTime]="true" [hourFormat]="'24'" [appendTo]="'body'" />
                          <label for="calendar-end-date">End Date</label>
                        </p-floatLabel>
                        } @else if (filter.operator === filterOperatorKeys.BETWEEN || filter.operator ===
                        filterOperatorKeys.NOT_BETWEEN) {
                        <input type="text" placeholder="Start Value" [(ngModel)]="filter.fromValue"
                          class="ml-2 font-semibold text-center"
                          (keypress)="onFilterInputKeyPress($event, filter.COLUMN_TYPE ?? '')" />
                        <input type="text" placeholder="End Value" [(ngModel)]="filter.toValue"
                          class="ml-2 font-semibold text-center"
                          (keypress)="onFilterInputKeyPress($event, filter.COLUMN_TYPE ?? '')">
                        } @else {
                        <input type="text" placeholder="value" [(ngModel)]="filter.values"
                          class="ml-2 font-semibold text-center"
                          (keypress)="onFilterInputKeyPress($event, filter.COLUMN_TYPE ?? '')" />
                        }
                        <span class="ml-auto flex items-center">
                          <button
                            class="bg-[#0F49A0] hover:bg-[#0f4ea0] transition text-white px-4 h-10 rounded-lg mr-2 flex items-center justify-center disabled:bg-[#5D5D5D] disabled:cursor-not-allowed"
                            [disabled]="isUpdateButtonDisabled(filter)"
                            (click)="updateFilter(filter)">Update</button>
                          <button
                            class="bg-red-100 hover:bg-red-200 transition px-4 h-10 rounded-lg ml-1 flex items-center justify-center"
                            (click)="clearEditedFilter(filter)">
                            <ui-icon name="close" class="stroke-red-600" size="size-5"></ui-icon>
                          </button>
                        </span>
                      </div>
                      } @else {
                      <!-- Applied Filters display -->
                      <div class="flex items-center justify-between p-2 rounded-lg shadow border border-[#cfd4dc]">
                        <div>
                          <span class="text-[#5D5D5D]  font-semibold pl-2">{{ filter.COLUMN_FQPN }}</span>
                          <span class="text-[#5D5D5D] font-semibold pl-4">({{ getOperatorValue(filter.operator)
                            }})</span>
                          @if (filter.fromDate && !filter.toDate){
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.fromDate| date:
                            (selectedDateTimeFormat === 'custom' ? customDateFormat : selectedDateTimeFormat) }} )</span>
                          }@else if((filter.operator === filterOperatorKeys.BETWEEN || filter.operator ===
                          filterOperatorKeys.NOT_BETWEEN) && filter.fromDate && filter.toDate ){
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.fromDate| date:
                            (selectedDateTimeFormat === 'custom' ? customDateFormat : selectedDateTimeFormat) }} )</span>
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.toDate| date:
                            (selectedDateTimeFormat === 'custom' ? customDateFormat : selectedDateTimeFormat) }} )</span>
                          }@else if ((filter.operator === filterOperatorKeys.BETWEEN || filter.operator ===
                          filterOperatorKeys.NOT_BETWEEN) && filter.fromValue && filter.toValue) {
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.fromValue }} )</span>
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.toValue }} )</span>
                          } @else{
                          <span class="text-[#5D5D5D] font-semibold pl-4">( {{ filter.values }} )</span>
                          }
                        </div>
                        <div class="mr-4">
                          <ui-icon name="pencil" class="inline-block ml-5 stroke-gray-700 hover:stroke-blue-700"
                            (click)="editFilter(filter)"></ui-icon>
                          <ui-icon name="trash" (click)="removeFilter(i)"
                            class="ml-5 stroke-[#B42318] inline-block cursor-pointer"></ui-icon>
                        </div>
                      </div>
                      }
                      <!-- Join section -->
                      @if(selectedFilters.length>1 && i !== (selectedFilters.length -1)){
                      <div class="pt-2">
                        <select [(ngModel)]="filter.join" (change)="onJoinEdited(filter, $event)"
                          class="font-semibold text-center">
                          <option value="" disabled selected>
                            Choose Join
                          </option>
                          <option *ngFor="let operator of filterJoinOperators" [value]="operator">
                            {{ operator }}
                          </option>
                        </select>
                      </div>
                      }
                    </li>
                    } @else {
                    <div class="flex items-center p-2 rounded-lg shadow border border-[#cfd4dc]">
                      <span class="font-semibold ml-2"> No filters applied </span>
                    </div>
                    }
                  </ul>
                </div>
              </div>
            </div>

            <!-- Apply cancel section -->
            <div class="mt-2 flex flex-row-reverse mr-1">
              <button
                class="text-sm font-semibold bg-[#0F49A0] hover:bg-[#0f4ea0] transition text-white px-4 h-10 rounded-lg mr-2 flex items-center justify-center disabled:bg-[#D0D5DD] disabled:text-[#7D7676] disabled:cursor-not-allowed"
                (click)="applyFilters()" [disabled]="!(isSelectedScope) || !(isCustomFormatValid())">
                Apply
              </button>

              <button
                class="text-sm font-semibold bg-[#0F49A0] hover:bg-[#0f4ea0] transition text-white px-4 h-10 rounded-lg mr-2 flex items-center justify-center"
                (click)="confirmFilterPopUpClose()">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Sections wrapper for Attributes and Measures -->
      <div class="sections-wrapper flex-1 flex flex-col overflow-hidden">
        <!-- Attributes Section -->
        <div
          class="section flex flex-col"
          [ngClass]="{
            'flex-1': isAttributesExpanded,
            'flex-none': !isAttributesExpanded
          }">
          <!-- Attributes Section Header -->
          <div class="section-header flex items-center border-b border-[#EAECF0] p-4 hover:bg-gray-50">
            <button class="flex items-center" (click)="toggleAttributes()">
              <img [src]="isAttributesExpanded ? 'assets/icons/chevron-down.svg' : 'assets/icons/chevron-right.svg'"
                alt="" class="mr-3 p-2 rounded-full hover:bg-gray-200" />
              <p class="text-[#475467] text-sm font-bold">Attributes</p>
            </button>
            <div class="ml-auto">
              <button class="p-2 rounded-full hover:bg-gray-200" (click)="expandAllTables('ATTRIBUTES'); $event.stopPropagation()">
                <img 
                  [src]="!allAttributeTablesExpanded ? 'assets/img/list-expand.svg' : 'assets/img/list-expand.svg'"
                  [alt]="allAttributeTablesExpanded ? 'Collapse All Tables' : 'Expand All Tables'"
                  [title]="allAttributeTablesExpanded ? 'Collapse All Tables' : 'Expand All Tables'"
                  class="w-5 h-5"
                />
              </button>
            </div>
          </div>
          <!-- End of Attributes Section Header -->

          <!-- Attributes Content Section -->
          <div class="panel-content"
          [ngClass]="{
            'content-expanded': isAttributesExpanded,
            'content-collapsed': !isAttributesExpanded
          }">
            <ul *ngIf="isAttributesExpanded" class="">
              <!-- Show skeleton immediately if attributes are loading -->
              <ng-container *ngIf="isAttributesLoading; else actualAttributes">
                <li *ngFor="let row of [1, 2, 3]" class="py-1 px-2">
                  <div class="animate-pulse">
                    <div class="overflow-x-auto">
                      <table class="w-full text-sm">
                        <tbody>
                          <tr>
                            <td class="py-1">
                              <!-- Reduced vertical gap: margin-bottom is set to 4px -->
                              <div class="h-6 bg-gray-100 rounded" style="margin-bottom: 4px;"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </li>
              </ng-container>
              
              <!-- Actual attributes content -->
              <ng-template #actualAttributes>
                <ng-container *ngIf="filteredTablesForAttributes.length > 0; else initialStateForAttributes">
                  <li *ngFor="let table of filteredTablesForAttributes" class="border-b border-white">
                    <div class="flex items-center py-2 px-4 hover:bg-gray-50 border-b border-[#EAECF0]">
                      <button class="flex items-center flex-1" (click)="toggleTable(table.id, 'ATTRIBUTES')">
                        <img [src]="table.expanded ? 'assets/icons/chevron-down.svg' : 'assets/icons/chevron-right.svg'"
                            alt=""
                            class="mr-3 p-2 rounded-full hover:bg-gray-200" />
                        <ui-icon name="table-icon" size="size-4" class="stroke-[#667085] mr-3" />
                        <span class="text-sm font-medium" [class.text-[#77ABF9]]="isTableColumnChecked(table, false)" 
                              [innerHTML]="table.name | highlight: searchTerm">
                        </span>
                      </button>
                      <span *ngIf="isTableColumnChecked(table, false)" class="ml-2 px-2 py-0.5 text-xs rounded-full bg-[#77ABF9] text-white">
                        {{ isTableColumnChecked(table, false) }}
                      </span>
                    </div>
                    <div *ngIf="table.loading" class="pl-16">
                      <skeleton-app-flat-hierarchy [contentWidth]="'w-36'" />
                    </div>
                    <ul *ngIf="table.expanded" class="">
                      <li *ngFor="let column of table.columns" class="">
                        <div *ngIf="!isNumericType(column.parameters?.TYPE)"
                            class="text-[#475467] flex items-center pl-[2rem] text-xs justify-between">
                          <div class="flex items-center py-2 px-8 hover:bg-gray-50">
                            <input type="checkbox"
                                  class="mr-3 w-4 h-4 rounded border-gray-300 text-[#77ABF9] focus:ring-[#77ABF9] disabled:cursor-not-allowed disabled:opacity-50"
                                  [(ngModel)]="column.checked"
                                  [disabled]="isExecutingReport"
                                  (change)="onColumnCheckedChange(column, table.id)" />
                            <img [src]="getColumnIcon(column.parameters?.TYPE)"
                                [alt]="column.parameters?.TYPE || 'column'"
                                [title]="column.parameters?.TYPE"
                                class="mr-2 w-6 h-4" />
                            <span class="text-sm flex-1"
                                  [innerHTML]="column.name | highlight: searchTerm"></span>
                          </div>
                          <div class="ml-2 mr-1">
                            <button class="p-1.5 rounded hover:bg-gray-200" [class.opacity-50]="!column.checked"
                                    [title]="column.checked ? 'Apply SQL Function' : 'Select the column to Apply SQL Function'"
                                    (click)="$event.stopPropagation(); (column.checked ? openSqlFunctionsDropDown(column, $event) : null)">
                              <img [src]="sqlFunctionMap[column.id] ? 'assets/icons/function.svg' : 'assets/icons/function-gray.svg'"
                                  alt="Function"
                                  class="w-4 h-4" />
                            </button>
                            <div *ngIf="column.isSQLFunctionDropdownOpen"
                                class="fixed bg-white border rounded shadow-lg right-45 w-32 z-50 ml-5"
                                [ngStyle]="sqlFunctionDropDownStyle"
                                (click)="$event.stopPropagation()">
                              <ul class="p-2">
                                <li *ngFor="let function of getSqlFunctions(column.parameters?.TYPE)"
                                    class="hover:bg-[#77ABF9] hover:text-white px-2 py-2 cursor-pointer flex items-center"
                                    [ngClass]="{'bg-[#77ABF9] text-white': checkIfFunctionApplied(column.id, function)}"
                                    [title]="column.checked ? '' : 'Column must be selected first to apply function'"
                                    (click)="column.checked ? applySQLFunctionToSelectedColumn(column, table?.id, function) : null">
                                  {{ function }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ng-container>
                <ng-template #initialStateForAttributes>
                  <li>
                    <div class="py-16 px-4">
                      <p class="text-[#475467] text-center text-sm">
                        {{ searchTerm.length
                          ? 'No matching tables or columns found. Please refine your search criteria and try again.'
                          : 'Select a scope to see data here' }}
                      </p>
                    </div>
                  </li>
                </ng-template>
              </ng-template>
            </ul>
          </div>            
          <!-- End of Attributes Content Section -->
        </div>
        <!-- End of attributes section -->

        <!-- Measures Section -->
        <div
          class="section flex flex-col"
          [ngClass]="{
            'flex-1': isMeasuresExpanded,
            'flex-none': !isMeasuresExpanded
        }">
          <!-- Measures Section Header -->
          <div class="section-header flex items-center border-b border-[#EAECF0] p-4 hover:bg-gray-50">
            <button class="flex items-center" (click)="toggleMeasures()">
              <img [src]="isMeasuresExpanded ? 'assets/icons/chevron-down.svg' : 'assets/icons/chevron-right.svg'"
                alt="" class="mr-3 p-2 rounded-full hover:bg-gray-200" />
              <p class="text-[#475467] text-sm font-bold">Measures</p>
            </button>
            <div class="ml-auto">
              <button class="p-2 rounded-full hover:bg-gray-200" (click)="expandAllTables('MEASURES'); $event.stopPropagation()">
                <img 
                  [src]="!allMeasureTablesExpanded ? 'assets/img/list-expand.svg' : 'assets/img/list-expand.svg'"
                  [alt]="allMeasureTablesExpanded ? 'Collapse All Tables' : 'Expand All Tables'"
                  [title]="allMeasureTablesExpanded ? 'Collapse All Tables' : 'Expand All Tables'"
                  class="w-5 h-5"
                />
              </button>
            </div>
          </div>
          <!-- End of Measures Section Header -->

          <!-- Measures Content Section -->
          <div class="panel-content"
          [ngClass]="{
            'content-expanded': isMeasuresExpanded,
            'content-collapsed': !isMeasuresExpanded
          }">
            <ul *ngIf="isMeasuresExpanded" class="">
              @if(templateTypesLoading){
              <li>
                <div class="pl-8">
                  <skeleton-app-flat-hierarchy [contentWidth]="'w-40'" />
                </div>
              </li>
              }@else{
              <ng-container *ngIf="filteredTablesForMeasures.length > 0; else initialStateForMeasures">
                <li *ngFor="let table of filteredTablesForMeasures" class="border-b border-white">
                  <div class="flex items-center py-2 px-4 hover:bg-gray-50 border-b border-[#EAECF0]">
                    <button class="flex items-center flex-1" (click)="toggleTable(table.id, 'MEASURES')">
                      <img [src]="table.expanded ? 'assets/icons/chevron-down.svg' : 'assets/icons/chevron-right.svg'"
                        alt="" class="mr-3 p-2 rounded-full hover:bg-gray-200" />
                      <ui-icon name="table-icon" size="size-4" class="stroke-[#667085] mr-3" />
                      <span class="text-sm font-medium" [class.text-[#77ABF9]]="isTableColumnChecked(table, true)" [innerHTML]="table.name  | highlight: searchTerm">
                      </span>
                    </button>
                    @if(isTableColumnChecked(table, true)) {
                    <span class="ml-2 px-2 py-0.5 text-xs rounded-full bg-[#77ABF9] text-white">
                      {{ isTableColumnChecked(table, true) }}
                    </span>
                    }
                  </div>
                  @if(table.loading){
                  <div class="pl-16">
                    <skeleton-app-flat-hierarchy [contentWidth]="'w-36'" />
                  </div>
                  }@else{
                  <ul *ngIf="table.expanded" class="">
                    <li *ngFor="let column of table.columns">
                      <div *ngIf="isNumericType(column.parameters?.TYPE)"
                        class="text-[#475467] flex items-center pl-[2rem] text-xs justify-between">
                        <div class="flex items-center py-2 px-8 hover:bg-gray-50">
                          <input type="checkbox"
                            class="mr-3 w-4 h-4 rounded border-gray-300 text-[#77ABF9] focus:ring-[#77ABF9] disabled:cursor-not-allowed disabled:opacity-50"
                            [(ngModel)]="column.checked"
                            [disabled]="isExecutingReport"
                            (change)="onColumnCheckedChange(column, table.id)" />
                          <img [src]="getColumnIcon(column.parameters?.TYPE)"
                            [alt]="column.parameters?.TYPE || 'column'" [title]="column.parameters?.TYPE" class="mr-2 w-6 h-4" />
                          <span class="text-sm flex-1" [innerHTML]="column.name  | highlight: searchTerm" ></span>
                        </div>
                        <div class="ml-2 mr-1">
                          <button class="p-1.5 rounded hover:bg-gray-200" [class.opacity-50]="!column.checked"
                            [title]="column.checked ? (!sqlFunctionMap[column.id] ? 'Measures must have a SQL Function applied' : 'Apply SQL Function') : 'Select the column to Apply SQL Function'"
                            (click)="$event.stopPropagation();(column.checked ? openSqlFunctionsDropDown(column, $event) : null)">
                            <img
                            [src]="column.checked ? 
                            (getSQLFunctionForColumn(column.id) ? 'assets/icons/function.svg' : 'assets/icons/function-red.svg') : 
                            'assets/icons/function-gray.svg'" 
                              alt="Function" class="w-4 h-4"
                              [style]="{'border': column.checked && !sqlFunctionMap[column.id] ? '1px solid red' : ''}" />
                          </button>
                          <div *ngIf="column.isSQLFunctionDropdownOpen"
                            class="fixed bg-white border rounded shadow-lg right-45 w-32 z-50 ml-5"
                            [ngStyle]="sqlFunctionDropDownStyle" (click)="$event.stopPropagation()">
                            <ul class="p-2">
                              <li *ngFor="let function of getSqlFunctions(column.parameters?.TYPE)"
                                class="hover:bg-[#77ABF9] hover:text-white px-2 py-2 cursor-pointer flex items-center"
                                [ngClass]="{'bg-[#77ABF9] text-white': checkIfFunctionApplied(column.id, function)}"
                                (click)="applySQLFunctionToSelectedColumn(column, table?.id, function)">
                                {{ function }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  }
                </li>
              </ng-container>
              }
              <ng-template #initialStateForMeasures>
                <li>
                  <div class="py-16 px-4">
                    <p class="text-[#475467] text-center text-sm">
                      Select a scope to see data here
                    </p>
                  </div>
                </li>
              </ng-template>
            </ul>
          </div>
          <!-- End of Measures Content Section -->
        </div>
        <!-- end of measures section -->
      </div>
    </div>

    <!-- Fixed bottom controls -->
    <div class="fixed-bottom-controls w-full bg-white border-t border-[#EAECF0]">
      <div class="flex items-center justify-end gap-4 mb-1 pt-2 mr-4 border-t border-[#EAECF0]">
        <button class="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100"
          [disabled]="!(isSelectedScope && isValidSelection && isNewState)"
          (click)="cancelReport()">
          Cancel
        </button>
        <div class="relative group">
          <button
            class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-[#0F49A0] hover:bg-[#0f4ea0] disabled:bg-gray-300 disabled:text-gray-500"
            [disabled]="!(isSelectedScope && isValidSelection) || isRunDisabled"
            (click)="executeReportData(true)">
            Run
          </button>
          <!-- Toast -->
          <div *ngIf="!(isSelectedScope && isValidSelection)"
            class="fixed hidden warning-toast group-hover:block p-2 border border-[#FDA29B]
              rounded-lg bg-[#FFFBFA] text-[#B42318]
              z-50 shadow-md">
            <div class="flex items-center">
              <img src="assets/icons/alert.svg" class="mr-2 size-5" />
              <div>
                <p class="font-medium leading-none text-xs">
                  <span *ngIf="!isSelectedScope">Please select a Data Scope</span>
                  <span *ngIf="isSelectedScope && !isValidSelection">
                    Atleast one column must be selected as an Attribute or Measure. Measures must have a SQL Function Applied.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if(isScopeOverViewPopUpOpen && selectedScope){
  <app-scope-overview-popup (closePopup)="isScopeOverViewPopUpOpen = false"
    [selectedScopeId]="selectedScope.id"></app-scope-overview-popup>
  }
</div>